export enum UserRole {
  ADMIN = 'admin',
  CALIBRATOR = 'calibrator',
  CHANNEL_PARTNER = 'channel_partner',
  MANAGER = 'manager',
  ROOT = 'root',
  USER = 'user',
  VIEWER = 'viewer',
}
